import { Injectable, signal } from '@angular/core';

export type AppTheme = 'light' | 'dark';

const STORAGE_KEY = 'of-theme';
const SF_LINK_ID = 'sf-theme';
const SF_LIGHT_CSS = 'cigp-syncfusion-bootstrap5.3.min.css';
const SF_DARK_CSS = 'cigp-syncfusion-bootstrap5.3-dark.min.css';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly isDark = signal(false);

  constructor() {
    const stored = localStorage.getItem(STORAGE_KEY) as AppTheme | null;
    this.isDark.set(stored === 'dark');
  }

  toggle(): void {
    const newDark = !this.isDark();
    this.isDark.set(newDark);
    this.apply(newDark ? 'dark' : 'light');
  }

  private apply(theme: AppTheme): void {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
    this.swapSyncfusionCss(theme);
  }

  private swapSyncfusionCss(theme: AppTheme): void {
    const link = document.getElementById(SF_LINK_ID) as HTMLLinkElement | null;
    const href = theme === 'dark' ? SF_DARK_CSS : SF_LIGHT_CSS;
    if (link) {
      link.href = href;
    }
  }
}
